import type { IconName } from '@hotjar/hotsauce';
import { Icon, Stack, Text } from '@hotjar/hotsauce';
import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { WidgetSummaryError } from './WidgetSummaryError';

const StyledStack = styled(Stack)`
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`;

export interface WizardSummaryBulletProps {
  icon: IconName;
  content: ReactNode;
  hasError?: boolean;
  errorMessage?: string;
}

export const WidgetSummaryBullet = ({
  icon,
  content,
  hasError,
  errorMessage,
}: WizardSummaryBulletProps): JSX.Element => {
  return (
    <StyledStack>
      {hasError === true ? (
        <WidgetSummaryError errorMessage={errorMessage ?? 'Unknown error'} />
      ) : (
        <>
          <StyledIcon icon={icon} color="text_default" />
          <Text textType="body2">{content}</Text>
        </>
      )}
    </StyledStack>
  );
};
